import { useTranslation } from 'react-i18next';
import { AlertIcon } from '../icons/AlertIcon';
import classes from './ErrorWarning.module.scss';

export const ErrorWarning = () => {
  const { t: translate } = useTranslation();
  return (
    <div className={classes['error-container']} data-testid="error-dialog">
      <AlertIcon /> <span>{translate('network_error.error_message')}</span>
    </div>);
};
